import React from "react"
import Page from "../../pages_/services/content-services/custom-outreach.page";

export default () => (

  <Page />

)